export enum SchedulesRoutes {
  schedules = 'schedules',
  companyShifts = 'company-shifts',
}
